import React from "react";
import {
  FiZap,
  FiUsers,
  FiTrendingUp,
  FiChevronDown,
} from "react-icons/fi";
import "./FeedFilters.css";

// Tab configuration with icons
const feedTabs = [
  { id: "personalized", label: "For You", icon: FiZap },
  { id: "following", label: "Following", icon: FiUsers },
  { id: "trending", label: "Trending", icon: FiTrendingUp },
];

const filterOptions = [
  { value: "all", label: "All Posts" },
  { value: "text", label: "Text Posts" },
  { value: "photo", label: "Photo Posts" },
  { value: "question", label: "Questions" },
  { value: "research", label: "Research Papers" },
  { value: "collaboration", label: "Collaborations" },
  { value: "poll", label: "Polls" },
  { value: "milestone", label: "Milestones" },
  { value: "repost", label: "Reposts" },
];

const FeedFilters = ({
  feedType,
  onFeedTypeChange,
  filter,
  onFilterChange,
}) => {
  return (
    <div className="cbx-feed-filters">
      <div className="cbx-filters-row">
        {/* Feed Type Tabs */}
        <div className="cbx-feed-tabs">
          {feedTabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = feedType === tab.id;

            return (
              <button
                key={tab.id}
                className={`cbx-feed-tab ${
                  isActive ? "cbx-feed-tab--active" : ""
                }`}
                onClick={() => onFeedTypeChange(tab.id)}
              >
                <Icon className="cbx-feed-tab-icon" />
                <span className="cbx-feed-tab-text">{tab.label}</span>
              </button>
            );
          })}
        </div>

        {/* Post Type Filter Dropdown */}
        <div className="cbx-filter-select-wrapper">
          <select
            className="cbx-filter-select"
            value={filter || "all"}
            onChange={(e) =>
              onFilterChange(e.target.value === "all" ? null : e.target.value)
            }
          >
            {filterOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <FiChevronDown className="cbx-filter-select-icon" />
        </div>
      </div>
    </div>
  );
};

export default FeedFilters;
